import { render, staticRenderFns } from "./customTree.vue?vue&type=template&id=2767e967"
import script from "./customTree.vue?vue&type=script&lang=js"
export * from "./customTree.vue?vue&type=script&lang=js"
import style0 from "./customTree.vue?vue&type=style&index=0&id=2767e967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports